import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=68b9d83d&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports